import { render } from "./color_roof.vue?vue&type=template&id=f95eecec"
import script from "./color_roof.vue?vue&type=script&lang=js"
export * from "./color_roof.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__